/**
 * LocalStorage keys that hold user/session-specific or sensitive data.
 * Cleared on sign out so another user on the same device doesn't see them.
 */
const KEYS_TO_CLEAR_ON_SIGN_OUT = [
  'pomodoro-timer-state',
  'backlog-drawer-open',
  'luma_tour_week_shown',
  'luma_tour_history_step',
] as const;

const AI_SUMMARY_CACHE_PREFIX = 'ai_summary_';

/**
 * Removes all sensitive/cached user data from localStorage on sign out.
 * Does not clear theme preference (safe to keep for device).
 */
export function clearSensitiveStorage(): void {
  if (typeof window === 'undefined') return;

  for (const key of KEYS_TO_CLEAR_ON_SIGN_OUT) {
    localStorage.removeItem(key);
  }

  // Clear AI summary cache (keys like ai_summary_week, ai_summary_month)
  const keysToRemove: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key?.startsWith(AI_SUMMARY_CACHE_PREFIX)) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach((key) => localStorage.removeItem(key));
}
